import React from 'react'
import { QueryKey, useMutation } from 'react-query'

import { queryClient } from '@client/init'
import { useAlert } from '@hooks/useAlert'
import { useClient } from '@hooks/useClient'
import { useModal } from '@hooks/contexts/ModalContext/ModalContext'
import { PromotionStatusEnum } from '@interfaces/PromotionStatusEnum'
import {
  PromotionSaleApproveSectionAcceptProps,
  PromotionSaleApproveSectionProps,
} from './interface'

export function withPromotionSaleApproveSection(
  Component: React.FC<PromotionSaleApproveSectionProps>
) {
  function Hoc({
    requestId,
    promotionId,
    promotionName,
    startPromotion,
    endPromotion,
    createdAt,
    promotionDetail,
    ...props
  }: PromotionSaleApproveSectionAcceptProps) {
    const client = useClient()
    const alert = useAlert()
    const rejectModal = useModal({ modal: 'rejectPromotion' })
    const queryKey: QueryKey = ['promotion', 'sale', promotionId]

    const { mutateAsync: approvePromotionSale } = useMutation(
      (promotionRequestId: number) =>
        client!.promotionClient.updatePromotionRequest({
          id: promotionRequestId,
          status: PromotionStatusEnum.APPROVED,
        }),
      {
        onSuccess: () => {
          alert.success(`ดำเนินการสำเร็จ`)
          queryClient.invalidateQueries(queryKey)
        },
        onError: () => {
          alert.error(`เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง`)
        },
      }
    )

    function handleApprove() {
      if (requestId) {
        approvePromotionSale(requestId)
      }
    }

    function handleReject() {
      rejectModal.show({
        requestId,
        promotionId,
        promotionName,
        startPromotion,
        endPromotion,
        createdAt,
        promotionDetail,
        onSuccess: () => {
          queryClient.invalidateQueries(queryKey)
        },
      })
    }
    const newProps = {
      ...props,
      promotionId,
      handleApprove,
      handleReject,
    }
    return <Component {...newProps} />
  }
  return Hoc
}
